import api from './axios';

const BASE_URL = import.meta.env.VITE_API_BASE_URL;
// Get current subscription for owner
export async function getCurrentSubscription() {
    const token = localStorage.getItem('token');
    const res = await fetch(`${BASE_URL}/core/subscription/current/`, {
        headers: {
            'Authorization': 'Token ' + token
        }
    });
    if (!res.ok) {
        const errorText = await res.text();
        console.error('Failed to fetch current subscription:', res.status, errorText);
        throw new Error(`Failed to fetch current subscription: ${res.status}`);
    }
    
    // Check if response is JSON
    const contentType = res.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
        const responseText = await res.text();
        console.error('Non-JSON response received:', responseText.substring(0, 200));
        throw new Error('Received non-JSON response from API');
    }
    
    return await res.json();
}

// List active plans
export const getActivePlans = async() => {
    const res = await api.get('/core/subscription/plans/');
    return res.data;
};

// Update / renew subscription with a plan_id
export const updateSubscription = async(planId) => {
    const res = await api.post('/core/subscription/update/', { plan_id: planId });
    return res.data;
};